module.exports = __webpack_public_path__ + "static/img/about-us.6830db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/about-us.png
// module id = xQ3r
// module chunks = 0